export enum ModuleEnum {
  Admin = 1,
  Employee = 2,
  HrAdmin = 3,
  Applicant = 4,
  CampusRecruiter = 5,
  UniversityAdmin = 6,
  Student = 7
}
